import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';
import { AuthService } from '../utils/auth.service';

@Injectable()
export class AuthGuard  {

  constructor(
    private authService: NbAuthService,
    private router: Router,
  ) {
  }

  canActivate() {
    return this.authService.isAuthenticated()
      .pipe(
        tap((authenticated) => {
          if (!authenticated) {
            AuthService.resetLocalStorage();
            let queryParams = {};
            if (!window.location.hash.includes('auth')) {
              queryParams['returnUrl'] = window.location.hash;
            }
            this.router.navigate(['auth', 'login'], { queryParams });
          }
        }),
      );
  }
}
